
import { LoaderCircle, Settings } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchSettings } from "../settings/settingsApi";

export default function FeatureGuard({ feature, children }) {
  const navigate = useNavigate();
  const [state, setState] = useState({ loading: true, enabled: true });
  useEffect(() => { let alive = true; fetchSettings().then((settings) => { if (alive) setState({ loading: false, enabled: feature ? settings?.features?.[feature] !== false : true }); }).catch(() => { if (alive) setState({ loading: false, enabled: true }); }); return () => { alive = false; }; }, [feature]);
  if (state.loading) return <div className="inventory-loading"><LoaderCircle size={22} className="admin-spin"/> Checking feature access...</div>;
  if (!state.enabled) return <section className="admin-page"><div className="settings-card"><Settings size={24}/><h2>Not available</h2><p>This feature is disabled in SugaLumps settings. Existing data is preserved.</p><button type="button" className="btn" onClick={()=>navigate("/admin/settings")}>Open Settings</button></div></section>;
  return children;
}
